import WorkspaceSettings from "./WorkspaceSettings"

export default WorkspaceSettings